export default __webpack_public_path__ + "static/media/energyrm-logo_small.bfc360d9.svg";